export default "__VITE_ASSET__Dhz3YNT6__"